<template>
  <div>
	  <div class="nav-container">
	    <nav class="navbar sticky-top">
	    </nav>
	  </div>

    <h3 class="err-msg text-center">{{ message }}</h3>
    <div class="text-center">
      <!-- TODO: change image -->
      <img :src="image" width="50%">
      <h3 v-if="isShowRequestNew">Yikes!</h3>
      <br/><br/>
      <h4><a href="/request-demo" v-if="isShowRequestNew">Request a new one.</a></h4>
      <br>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { IMAGE_404 } from '@/api/constants/ImageAssets'
import Footer from '@/components/common/Footer'

export default {
  components: {
    Footer
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: IMAGE_404
    },
    isShowRequestNew: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.err-msg {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/components/Page404.vue